import React, { useState } from 'react'
import Navbar from '../Navbar/Navbar'

function Contact() {
    const [blur, setBlur] = useState(false)
    const searchDialogOpen = (NavbarData) => {
        setBlur(NavbarData)

    }

    return (
        <div>
            <Navbar handleNavbar={searchDialogOpen} />
            <div className='container ' style={{ marginTop: "5rem" }}>
                <h2 className='text-center'><b>Company Details</b></h2>
                <ol className=' ol-head-roman ps-0'>
                    <h4 className=' mt-4'><b>Provider of the website:</b></h4>
                    <p>Go2Taste Limited, private limited company 1602; 49 Goulden street Manchester, M8 0SE UNITED kingdom</p>
                </ol>
                <h5>Contact us:</h5>
                <p className='text-secondary'>Email address: info@gotaste.uk</p>
                <p className='text-secondary'>GoTaste support: help@gotaste.uk</p>
                <p className='text-secondary'>GoTaste is the wholly owned trading name of Go2Taste limited</p>

            </div>

        </div>
    )
}

export default Contact